/**
 * plugins/icons.ts
 *
 * Exposes the icon catalog to every component template as `$icons`, so a
 * component that only needs a glyph does not have to import `ICONS` and
 * re-export it from `setup()`:
 *
 *   <v-icon :icon="$icons.edit" />
 *
 */

import { ICONS } from "@/libs/icons";
import type { App } from "vue";

export default {
  install(app: App) {
    app.config.globalProperties.$icons = ICONS;
  },
};

declare module "vue" {
  interface ComponentCustomProperties {
    $icons: typeof ICONS;
  }
}
